module.exports = __webpack_public_path__ + "img/tech.048d951c.png";